import { competitiveIntelligenceResearchTranslations } from './competitive-intelligence-research'
import { analyticsTranslations } from './analytics'

export const static_translation = {
    password_change_title: "Choose your individual password",
    password_change_description: "Your sign-in was accepted. Choose one individual password of at least 8 characters for all your areas. Your existing access will stay the same.",
    password_change_save: "Save password and continue",
    password_change_error: "Enter matching new passwords with at least 8 characters. Choose an individual password.",
    profile_completion_country: "Country",
    profile_completion_company: "Company or institution",
    profile_completion_job_title: "Job title",

    profile_completion_title: "Complete your profile",
    profile_completion_description: "Your access is active. Add only the missing details to continue.",
    profile_completion_save: "Save and continue",
    profile_completion_error: "We could not save your details. Refresh the page to check your access and try again.",

    area_eyebrow: "YOUR MAGVENTURE ACCOUNT",
    area_heading: "Where would you like to go?",
    area_subtitle: "Choose an area to continue. Your access is already connected.",
    area_universe_name: "Universe",
    area_lite_name: "Lite",
    area_accelerator_name: "Accelerator",
    area_universe_description: "Your MagVenture knowledge and resources.",
    area_lite_description: "Essential learning, ready to explore.",
    area_accelerator_description: "Your training and development program.",
    area_enter: "Enter",
    area_opening: "Opening…",
    area_loading: "Checking your access…",
    area_footer: "One account. Access to your available areas.",
    area_sign_out: "Sign out",
    area_error: "We could not confirm your access. Please try again.",
    area_retry: "Try again",
    area_empty: "There are no active areas for your account. Please contact your administrator.",
    area_login_error: "Unable to sign in. Check your credentials and try again.",

    sf_partner_contact_account: "If the selected Contact has no Account, approval reuses a matching Account or prepares one using the reviewed company name and links that Contact. No additional person is created. If multiple Accounts match, choose the correct Account card.",
    sf_partner_account_reuse: "Account to reuse at confirmation",
    sf_partner_account_create: "Account to create at confirmation",
    sf_partner_title: "Prepare Salesforce organization and person",
    sf_partner_intro: "For markets without a subsidiary, an existing Account will be reused and the new person created as a linked Contact. If no Account exists, approval creates an Account using the reviewed company name and a new Lead. Existing Contacts and Leads are reused.",
    sf_partner_link: "For a new Lead, Company stores the reviewed organization name. The user-to-Account link is stored in Universe; this Salesforce configuration has no direct Lead-to-Account lookup. New Accounts use Qualified Lead status.",
    sf_partner_existing_lead: "This existing Lead will be reused. Approval does not create a duplicate person or automatically convert the Lead.",
    sf_partner_account_choice: "More than one Account matches this company. Choose the correct Account card before approval; no duplicate Account will be created.",
    sf_review_none_match: "None of these people matches this registration. Create a new Contact.",
    sf_review_reason: "Explain your identity decision (required)",
    sf_review_evidence: "Matching information",
    sf_review_differences: "Different information",
    sf_review_reason_contact_creation_required: "Select the Account. A new Contact will be created there when you confirm approval.",
    sf_review_reason_account_selection_required: "Review the Contact and select its Account. An Account change requires your confirmation.",
    sf_review_reason_salesforce_identity_unconfirmed: "Possible existing people were found. Select the correct Contact or confirm that none corresponds to this registration.",
    sf_review_reason_lead_conversion_required: "An existing Lead matches this email. Convert it in Salesforce, then reload the records.",
    sf_review_reason_salesforce_identity_ambiguous: "Multiple people match this email. Compare their details and select the correct Contact.",
    sf_review_reason_salesforce_record_deleted: "A matching record was deleted. Resolve it in Salesforce and reload before approving.",
    sf_review_reason_partner_creation_ambiguous: "A previous creation has an uncertain result. Reconciliation must finish before another record can be created.",
    sf_review_reason_ready: "The Contact and Account are available. Confirm the selected association.",
    sf_review_field_email: "Email",
    sf_review_field_phone: "Phone",
    sf_review_field_firstName: "First name",
    sf_review_field_lastName: "Last name",
    sf_review_field_fullName: "Full name",
    sf_review_field_emailLocalPart: "Email name",
    sf_review_field_emailDomain: "Email domain",
    sf_review_field_accountId: "Account",
    sf_review_field_companyName: "Company",
    sf_review_field_city: "City",
    sf_review_field_state: "State",
    sf_review_field_country: "Country",
    sf_review_field_title: "Title",
    sf_review_title: "Review Salesforce identity",
    sf_review_intro: "Compare the current Salesforce records, then choose the Contact and Account for this registration. Records with the same name are distinguished by their Salesforce IDs.",
    sf_review_loading: "Loading current Salesforce records…",
    sf_review_retry: "Reload Salesforce records",
    sf_review_contact: "Select the Salesforce Contact",
    sf_review_account: "Select the Salesforce Account",
    sf_review_no_account: "No Account linked",
    sf_review_current: "Current Universe link",
    sf_review_unavailable: "Unavailable for selection",
    sf_review_company: "Account",
    sf_review_account_change: "I confirm the displayed change to this Contact’s Account in Salesforce.",
    sf_review_change: "Account change on confirmation",
    sf_review_history: "Existing records and historical activities are retained. Future Universe activity will use the selected Contact. No records are merged or deleted.",
    sf_review_commit: "Confirmation saves the selected identity and organization, then approves access.",
    sf_review_leads: "Salesforce Leads also found",
    sf_review_conversion: "A Lead must be converted to a Contact in Salesforce before it can be selected here. Reload after conversion.",
    sf_review_no_person: "No existing Contact found. The reviewed company selection below will be used to create the Contact before approval.",
    sf_review_created: "Created",
    sf_review_stale: "The previous integration attempt used an older profile revision. Your confirmation will review the current data before resuming.",

    identity_management_title: 'User access management',
    identity_management_search: 'Search by name, email or company',
    identity_management_role: 'Role',
    identity_management_profile: 'Profile',
    identity_management_invite: 'Grant access by invitation',
    identity_management_review: 'Review pending requests',
    identity_management_invite_ready: 'Invitation ready',
    identity_management_invite_bound: 'Only this existing account can accept the invitation. No email has been sent.',
    identity_management_open_invite: 'Open invitation',
    identity_management_invite_terms: 'One use, for this account only. Lite access lasts 30 days after acceptance; Accelerator invitations expire in 30 days. Existing content rules apply.',
    identity_management_migration: 'Compatibility',
    identity_migration_preserve_legacy_credentials: 'Existing portal password preserved',
    identity_migration_missing_credentials: 'Password setup required',
    identity_migration_duplicate_email: 'Duplicate email — identity review required',
    identity_migration_access_flag_mismatch: 'Access conflict — review required',
    identity_migration_linked_email_mismatch: 'Profile link requires review',
    identity_migration_missing_established_link: 'Identity link requires review',
    identity_management_suspend: 'Suspend access',
    identity_management_restore: 'Restore previous access',
    identity_management_revoke: 'Revoke access',
    identity_management_confirm: 'This decision affects only the selected area. Confirm to continue.',
    identity_management_saved: 'Access updated.',
    identity_management_confirm_action: 'Confirm',
    identity_management_approval_help: 'Universe access is granted through the pending user approval process.',
    identity_management_invite_help: 'New access requires an invitation for this area. The user accepts it with their existing account.',
    identity_access_title: 'My access',
    identity_access_subtitle: 'Your MagVenture areas and access requests.',
    identity_access_area: 'Area',
    identity_access_enter: 'Open',
    identity_access_unavailable: 'Access is unavailable',
    identity_request_universe: 'Request Universe access',
    identity_request_explanation: 'Your current access continues while your Universe request is reviewed.',
    identity_request_submit: 'Send request',
    identity_request_sent: 'Your request has been sent for review.',
    identity_status_active: 'Active',
    identity_status_pending: 'Awaiting review',
    identity_status_suspended: 'Suspended',
    identity_status_revoked: 'Revoked',
    identity_status_rejected: 'Not approved',
    identity_status_none: 'Not requested',
    identity_status_legacy: 'Existing access',
    lite_invite_group_unavailable: 'No available content',
    lite_invite_access_time: 'Access Time',
    lite_invite_days: 'days',
    lite_invite_advanced: 'Advanced Options',
    lite_invite_default_content_help: 'All content configured for Lite is available by default. Use Advanced Options to customize access.',
    lite_invite_description: 'Create a reusable invitation for Universe Lite.',
    lite_invite_duration_help: 'Each person receives this access period when they complete registration. Changes apply only to future registrations.',
    lite_invite_legacy: 'This existing invitation keeps its original fixed-date rules. Its deadline remains available in Advanced Options.',

    ...analyticsTranslations.English,
    "student_invite_request": 'Guest form',
    "fill_invite_form_text": "Fill in your details and the invitation code you received.",
    "mvu_essentials_register_welcome": "Welcome to MagVenture Universe Lite",
    "mvu_essentials_register_access_notice": "Access with this code is limited to a specific number of people. Thank you for not sharing it.",
    "portal_registration_participant_limit_reached": "Registration is unavailable because the maximum number of participants for this access has been reached. Please contact the person responsible for your MagVenture access for assistance.",
    "portal_registration_invite_invalid": "This invitation link is invalid or has expired.",
    "lite_registration_success_title": "Registration complete",
    "lite_registration_success_email_text": "Your access to MagVenture Universe Lite is ready. We sent a welcome email with your access link. Sign in with the email and password you just registered.",
    "lite_registration_success_text": "Your access to MagVenture Universe Lite is ready. Sign in with the email and password you just registered.",
    "lite_registration_success_action": "Go to Lite login",
    "accelerator_registration_success_title": "Registration complete",
    "accelerator_registration_success_email_text": "Your access to the MagVenture Accelerator Program is ready. We sent a welcome email with your access link. Sign in with the email and password you just registered.",
    "accelerator_registration_success_text": "Your access to the MagVenture Accelerator Program is ready. Sign in with the email and password you just registered.",
    "accelerator_registration_success_action": "Go to Accelerator login",
    "please_confirm_you_are_not_a_robot": "Please confirm you are not a robot.",
    "full_name": "Full name",
    "institution": "Institution",
    "inviting_professor_name": "Professor inviting",
    "invitation_code": "Invitation code",
    "invite_request_sent": "Your request was sent. You can now log in.",
    "context": "Context",
    "upload_title": "Content Upload Request Form",
    "upload_success": "Upload submitted. Awaiting approval.",
    "describe_as_upload": "Fill in the information below and upload the files you would like to propose as new content to be uploaded to MagVenture Universe. In a few days, our Support Team will get in contact with you with further information about your request.",

    "title": "Title",
    "table": "Content type",
    "tags": "User Persona",
    "tag-types": "Filtering Options",
    "categories": "Categories",
    "sub-categories": "Subcategories",
    "document": "Document",
    "image": "Image",
    "audience_access_available_audiences": "Available audiences",
    "audience_access_hcp": "Available to HCPs",
    "audience_access_partner": "Available to Partners",
    "audience_access_staff_us": "Available to US Staff",
    "audience_access_staff_global": "Available to Global Staff",

    "cancel": "Cancel",
    "send": "Send",
    'share_link': 'Share link',
    'share_link_description': 'Anyone with this link can access this content for {days} days. Copy and share it safely.',
    'share_link_label': 'Share this link:',
    'copy_link': 'Copy link',
    'copied': 'Copied!',
    'share_link_warning': 'This link will expire in {days} days.',
    'share_link_duration': 'Validity (days)',
    'copy': 'Copy',
    "term_title": "Cookies and privacy statement",
    "register": "Register",
    "login": "Login",
    "email": "E-mail",
    "registration_professional_email_hint": "Please use your professional email, e.g. name@yourclinic.com.",
    "password": "Password",
    "signin": "Login",
    "session_expired_sign_in_again": "Your session has expired. Please sign in again to continue.",
    "reset_password": "Reset password",
    "fill_the_field": "Fill the field",
    "success": "Thank you!",
    "onboarding": "Onboarding Video",
    // "account_successfully_created": "Thank you for your interest in MagVenture Universe. The platform is still under development. We will come back to you soon.",
    "account_successfully_created": "Our team will review your request and contact you if further information is needed. You’ll receive an email once your account is approved and ready to use.",
    "close": "Close",
    "salutation": "Salutation",
    "first_name": "First Name",
    "last_name": "Last Name",
    "company_name": "Company Name",
    "job_title": "Job title / Position",
    "industry": "Industry",
    "state": "State/Province",
    "zipcode": "Zip/Postal code",
    "phone_number": "Phone number",
    "password_confirmation": "Password confirmation",
    "mr": "Mr",
    "mrs": "Mrs",
    "ms": "Ms",
    "signup": "Sign up",
    "are_you_a_patient_or_a_therapist": "Are you a patient or a therapist?",
    "create_your_password": "Create your password",
    "finish": "Finish",
    "create_your_account": "Create your account",
    "back": "Back",
    "next": "Next",
    "create_a_password": "Create a password",
    "enter_a_password_for_your_account": "Enter a password for your account",
    "subscribe_to_newsletter": "Yes, I would like to receive educational updates, TMS resources, and event information from MagVenture.",
    "subscribe_to_newsletter_information": "You can unsubscribe at any time. We respect your professional inbox and only share relevant content.",
    "i_accept_the": "I accept the",
    "i_accept_the_united": "US Privacy Policy",
    "privacy_policy": "Privacy Policy",
    "send": "Send",
    "back_to_login": "Back to login",
    "enter_your_email_to_recover_your_password": "Enter your email to recover your password",
    "access_the_recovery_link_that_was_sent_to_your_email": "Access the recovery link that was sent to your email",
    "check_your_email": "Check your e-mail",
    "new_password": "New password",
    "confirm_new_password": "Confirm new password",
    "new_password_and_new_password_confirmation_are_not_the_same": "New password and new password confirmation are not the same",
    "password_changed_successfully": "Password changed successfully!",
    "create_a_new_password": "Create a new password",
    "enter_a_new_password_for_your_account": "Enter a new password for your account",
    "save": "Save",
    "one_uppercase_letter": "One uppercase letter",
    "one_number": "One number",
    "at_least_6_characters": "At least 6 characters",
    "at_least_1_special_character": "At least 1 special character",
    "accept_terms": "Accept terms",
    "password_and_password_confirmation_must_match": "Password and password confirmation must match",
    "see_all": "See all",
    "watch_live_now": "Watch live now",
    "courses_available_for_you": "Programs available for you",
    "partners-and-staffs_available_for_you": "Partners and Staff available for you",
    "product-information_available_for_you": "Product information available for you",
    "articles_available_for_you": "Articles available for you",
    "podcasts_available_for_you": "Podcasts available for you",
    "documents_available_for_you": "Documents available for you",

    "support-materials_available_for_you": "Practice Support Materials available for you",
    "marketing-materials_available_for_you": "Practice Marketing Materials available for you",
    "service-supports_available_for_you": "Service & Support available for you",
    "product-informations_available_for_you": "Practice Product Informations available for you",
    "media-templates_available_for_you": "Social Media Templates available for you",
    "videos_available_for_you": "Videos available for you",
    "photos_available_for_you": "Photos available for you",

    "courses": "Training & Learning ",
    "knowledge-trails": "Learning Paths",
    "partners-and-staffs": "Partners and Staff",
    "product-information": "Product information",
    "articles": "Articles",
    "podcasts": "Podcasts",
    "documents": "Documents",
    "home": "Home",
    "favorites": "Favorites",
    "no_favorites_message": "You have not added any favorites yet.",
    "favorites_workspace_title": "Organize saved content",
    "favorites_workspace_description": "Create folders, drag items between them, and keep your saved materials easier to scan.",
    "favorites_unfiled": "Unfiled",
    "favorites_unfiled_caption": "New favorites land here first",
    "favorites_unfiled_description": "Everything you saved but have not organized into a folder yet.",
    "favorites_folder_description": "Drag items here, reorder them, or move several at once.",
    "favorites_new_folder": "New folder",
    "favorites_create_folder": "Create folder",
    "favorites_folder_name_placeholder": "Folder name",
    "favorites_delete_folder_confirm": "Delete this folder and move its items back to Unfiled?",
    "favorites_current_view": "Current view",
    "favorites_grid": "Grid",
    "favorites_list": "List",
    "favorites_drag_hint": "Drag to reorder or move",
    "favorites_selected": "selected",
    "favorites_move_to": "Move to",
    "favorites_move_selected": "Move selected",
    "favorites_empty_unfiled": "Save courses or files and they will appear here before you move them into a folder.",
    "favorites_empty_folder": "This folder is empty. Drag items here from another folder or use bulk move.",
    "faq": "FAQ",
    "no_faqs_available": "No frequently asked questions available.",
    "support": "Help",
    "contact_us": "Contact us",
    "my_account": "My Account",
    "my_certificates": "My Certificates",
    "logout": "Log Out",
    "search": "Search",
    "frequently_asked_questions": "Frequently Asked Questions",
    "how_can_we_help_you": "How can we help you?",
    "add_new_ticket": "Help request",
    "all_tickets": "All Requests",
    "pending": "Pending",
    "closed_tickets": "Closed Requests",
    "videos_and_contents": "Videos and contents",
    "ticket_information": "Requests information",
    "add_reply": "Add Reply",
    "close_ticket": "Close Requests",
    "status": "Status",
    "ticket_id": "Request ID",
    "created_date": "Created Date",
    "category_department": "Category/Department",
    "give_feedback": "Give feedback",
    "how_would_you_rate_the_way_this_request_was_handled": "How would you rate the way this request was handled",
    "subject": "Subject",
    "area_departament": "Area / departament",
    "message": "Message",
    "create_a_new_ticket": "Create a New Ticket",
    "describe_as_soon_as_possible": "Describe your issue and select the appropriate department so our team can assist you as soon as possible",
    "no_records_found": "No records found",
    "showing": "Showing",
    "of": "of",
    "results": "results",
    "subject_title": "Subject/Title",
    "last_updated": "Last Updated",
    "cancel": "Cancel",
    "registration_data": "Registration data",
    "updated_successfully": "Updated successfully",
    "created_successfully": "Created successfully",
    "edit": "Edit",
    "done": "Done",
    "filters": "Filters",
    "search.shareResources": "Share resources",
    "search.backToResults": "Back to results",
    "search.download": "Download",
    "search.filters": "Content types",
    "search.loading": "Searching",
    "search.error": "Search is unavailable",
    "search.errorHelp": "Please try your search again.",
    "search.start": "Enter at least two characters to search.",
    "search.degraded": "Related search is temporarily unavailable. Showing matches from the content catalog.",
    "search.refine": "Showing a limited set of matches. Refine your search for more specific results.",
    "search.result": "result",
    "search.results": "results",
    "search.noResults": "No results found for",
    "search.emptyHelp": "Check the product code or try fewer words. You can also choose All to search every content type.",
    "search.noDirect": "No direct matches found. These resources may be related to your search.",
    "search.related": "Related results",
    "search.showRelated": "Show related results",
    "search.types.all": "All",
    "search.types.videos": "Videos",
    "search.types.images": "Images",
    "search.types.documents": "Documents & materials",
    "search.types.learning": "Training & learning",
    "search.types.articles": "Articles",
    "search.sections.trainingLearning": "Training & Learning",
    "search.sections.documents": "Documents",
    "search.sections.images": "Images",
    "category": "Category",
    "filter": "Filter",
    "clear": "Clear",
    "support_materials": "Practice Support Materials",
    "marketing_materials": "Practice Marketing Materials",
    "media_templates": "Social Media Templates",
    "videos": "Videos",
    "photos": "Photos",
    "support-materials": "Practice Support Materials",
    "marketing-materials": "Marketing Materials",
    "sales-support-materials": "Sales Support Materials",
    "sales-support-materials_available_for_you": "Sales Support Materials available for you",
    "sales_support_materials_empty": "No sales support materials are available yet.",
    "sales_support_materials_error": "We could not load the sales support materials. Please try again.",
    "sales_support_materials_unavailable": "Sales support materials are temporarily unavailable",
    "service-supports": "Service & Support",
    "service_support": "Service & Support",
    "support_videos": "Support Videos",
    "support_videos_empty": "No support videos are available yet.",
    "support_videos_unavailable": "Support videos unavailable",
    "support_videos_error": "We couldn't load the support videos. Please try again.",
    "support_video_unavailable": "Support video unavailable",
    "support_video_media_missing": "Video not available",
    "support_video_media_missing_description": "This support video does not have playable media yet.",
    "support_video_about": "About this video",
    "product-informations": "Product Informations",
    "media-templates": "Social Media Templates",
    "login_title": "Please Sign In",
    "login_title_essentials": "Please Sign In to MagVenture Universe Lite",
    "accelerator_brand_name": "MagVenture",
    "accelerator_brand_program": "Accelerator Program",
    "login_title_accelerator": "Welcome to the MagVenture Accelerator Portal",
    "accelerator_welcome_intro": "This is your exclusive portal for everything you need to prepare for and participate in the MagVenture Accelerator.",
    "accelerator_welcome_details": "Here you’ll find clinical training focused specifically on Introduction to TMS, Major Depressive Disorder (MDD), and Obsessive Compulsive Disorder (OCD), along with materials and resources from the Accelerator program which will be posted after the program.",
    "accelerator_welcome_login": "Log in to access your training and Accelerator resources.",
    "welcome": "Welcome! This is your exclusive portal to clinical training, practice marketing assets, and media resources—including videos, treatment photos, and social media templates. Log in to access tools tailored to support your success with MagVenture.",
    "existing_users": "Existing Users",
    "enter_credentials_to_continue": "Enter your login credentials to continue where you left off.",
    "new_users": "New Users",
    "register_link_text": "Register",
    "register_and_gain_access_part1": "Need an account? Go to ",
    "register_and_gain_access_part2": " and gain full access to our exclusive learning and resource platform.",
    "contact": "Contact us",
    "contact.topicCategory": "Selec the topic category",
    "contact.topicCategory.label": "Topic Category",
    "contact.chooseSubject": "Choose the subject that best matches your request.",
    "contact.message": "Message",
    "contact.message.label": "Message",
    "contact.describeIssue": "Describe your issue in detail. Our team will respond as soon as possible.",
    "contact.fileAttachment": "Attach a file",
    "contact.fileAttachment.label": "File Attachment",
    "contact.attachmentHelp": "Optionally, you can attach a screenshot or file related to your request. (e.g. JPG, PNG, PDF, DOC)",
    "contact.preferredContact": "Preferred contact method",
    "contact.preferredContact.label": "Preferred Contact Method",
    "contact.contactPreference": "How do you prefer to be contacted regarding this issue?",
    "contact.maximum_characters": "Maximum: 1000 characters",
    "contact.email.label": "Email",
    "contact.phone.label": "Phone",
    "contact.technical_support": "Questions about the content in Magventure Universe",
    "contact.video_streaming": "Video streaming problem",
    "contact.questions_about_products": "Question about Magventure Product/Services",
    "contact.material_download": "Material download problem",
    "contact.suggestion": "Suggestion",
    "contact.other": "Other",
    "contact.file": "Choose Files",
    "contact.submit": "Submit",
    "contact.is_required": "is required",
    "contact.success": "Contact sent successfully",
    "register.undertems": "Access to MagVenture Universe is subject to review and approval. Registration requests may take up to 2 business days to be approved.",
    "courses-webnars-trainning": "Courses, Webinars and Trainings",
    "usshop": "US Shop",
    "chat": "Chat agent",
    "country": "Country",
    "verify_email": "Verify your email",
    "enter_the_code_sent_to_your_email": "Enter the code sent to your email",
    "we_sent_a_code_to_email": "We sent a verification code to",
    "enter_verification_code": "Enter verification code",
    "code_expires_in": "Code expires in",
    "verify": "Verify",
    "resend_code_in": "Resend code in",
    "resend_code": "Resend code",
    "a_new_code_has_been_sent": "A new code has been sent.",
    "please_confirm_you_are_not_a_robot": "Please confirm you are not a robot.",
    "email_verified_successfully": "Email verified successfully.",
    "continue": "Continue",
    "web_notifications_title": "Enable notifications",
    "web_notifications_description": "Receive course updates, support replies, and important activity directly in your browser.",
    "web_notifications_body": "Stay informed without keeping the platform open. You can change this later in your browser settings.",
    "web_notifications_bullet_updates": "New content, releases, and platform updates",
    "web_notifications_bullet_support": "Support replies and ticket progress",
    "web_notifications_bullet_reminders": "Important reminders when you are away from the tab",
    "web_notifications_enable": "Enable notifications",
    "web_notifications_later": "Maybe later",
    "web_notifications_enabled": "Notifications enabled successfully.",
    "web_notifications_not_supported": "This browser does not support web notifications.",
    "web_notifications_denied": "Notifications are blocked in your browser settings.",
    "notifications": "Notifications",
    "unread_notifications": "unread notifications",
    "unread_notification": "unread notification",
    "unread": "Unread",
    "mark_all_notifications_read": "Mark all as read",
    "notifications_update_error": "Unable to update notifications.",
    "try_again": "Try again",
    "notifications_load_error": "Unable to load notifications",
    "notifications_load_error_description": "Check your connection and try again.",
    "notifications_empty": "No notifications yet",
    "notifications_empty_description": "Updates and important activity will appear here.",
    "notification_not_found": "Notification not found",
    "notification_not_found_description": "This notification is no longer available or you do not have access to it.",
    "back_to_notifications": "Back to notifications",
    "open_notification": "Open",
    "loading_notifications": "Loading notifications",
    "loading_notification": "Loading notification",
    "notifications_subtitle": "Review updates, course releases, and important activity in one place.",
    "recent_activity": "Recent activity",
    "notifications_all_read": "You're all caught up",
    "staff_essentials_invites_title_required": "Title is required.",
    "staff_essentials_invites_updated": "Invite updated.",
    "staff_essentials_invites_created": "Invite created.",
    "staff_essentials_invites_link_unavailable": "Invite link is not available.",
    "staff_essentials_invites_link_copied": "Invite link copied.",
    "staff_essentials_invites_copy_prompt": "Copy this invite link:",
    "staff_essentials_invites_eyebrow": "MagVenture Universe",
    "staff_essentials_invites_menu_title": "MVU Lite Invitations",
    "staff_essentials_invites_title": "MVU Lite Invitations",
    "staff_essentials_invites_subtitle": "Create MagVenture Universe Lite invitation links and track how many registrations each link has consumed.",
    "staff_essentials_invites_refresh": "Refresh",
    "staff_essentials_invites_create": "Create invite",
    "staff_essentials_invites_total": "Total invites",
    "staff_essentials_invites_active": "Active",
    "staff_essentials_invites_registrations": "Registrations",
    "staff_essentials_invites_remaining": "Remaining",
    "staff_essentials_invites_links": "Invite links",
    "staff_essentials_invites_found_singular": "invite found",
    "staff_essentials_invites_found_plural": "invites found",
    "staff_essentials_invites_none_created": "No invite links created yet",
    "staff_essentials_invites_syncing": "Syncing",
    "staff_essentials_invites_live_data": "Live data",
    "staff_essentials_invites_loading_links": "Loading invite links...",
    "staff_essentials_invites_column_title": "Title",
    "staff_essentials_invites_column_link": "Link",
    "staff_essentials_invites_column_status": "Status",
    "staff_essentials_invites_column_used": "Used",
    "staff_essentials_invites_column_remaining": "Remaining",
    "staff_essentials_invites_column_expires": "Expires",
    "staff_essentials_invites_column_created": "Created",
    "staff_essentials_invites_column_actions": "Actions",
    "staff_essentials_invites_active_status": "Active",
    "staff_essentials_invites_inactive_status": "Inactive",
    "staff_essentials_invites_unlimited": "Unlimited",
    "staff_essentials_invites_copy_link": "Copy link",
    "staff_essentials_invites_history": "History",
    "staff_essentials_invites_edit": "Edit",
    "staff_essentials_invites_empty_title": "No Lite invites yet",
    "staff_essentials_invites_empty_description": "Create the first invite link to start tracking registrations.",
    "staff_essentials_invites_edit_modal": "Edit invite",
    "staff_essentials_invites_create_modal": "Create invite",
    "staff_essentials_invites_generated_by_strapi": "Choose a unique invite code and link it to a Salesforce Account.",
    "staff_essentials_invites_field_title": "Title",
    "staff_essentials_invites_field_code": "Invite code",
    "staff_essentials_invites_field_company": "Company Name",
    "staff_essentials_invites_code_required": "Invite code is required.",
    "staff_essentials_invites_company_required": "Company Name is required.",
    "staff_essentials_invites_column_company": "Company",
    "staff_essentials_invites_loading_companies": "Loading companies...",
    "staff_essentials_invites_search_companies": "Type to search companies.",
    "staff_essentials_invites_no_companies": "No companies found.",
    "staff_essentials_invites_company_select_required": "Select a Company from the list.",
    "staff_essentials_invites_field_maximum_uses": "No. of users having access to this invitation",
    "staff_essentials_invites_field_expires_at": "Expires at",
    "staff_essentials_invites_history_modal": "Invite history",
    "staff_essentials_invites_loading_history": "Loading history...",
    "staff_essentials_invites_no_institution": "No institution",
    "staff_essentials_invites_no_registrations": "No registrations for this invite yet.",
    "staff_essentials_invites_locked_content_title": "Content access",
    "staff_essentials_invites_locked_content_description": "Checked content is available to users who register with this invitation. Uncheck an item to block access.",
    "staff_essentials_invites_locked_content_selected": "with access",
    "staff_essentials_invites_locked_content_select_visible": "Grant access to visible results",
    "staff_essentials_invites_locked_content_clear": "Block all content",
    "staff_essentials_invites_locked_content_search": "Search Lite content",
    "staff_essentials_invites_locked_content_filter": "Content type",
    "staff_essentials_invites_locked_content_all_types": "All types",
    "staff_essentials_invites_locked_content_loading": "Loading catalog...",
    "staff_essentials_invites_locked_content_empty": "No matching content.",
    "staff_essentials_invites_locked_content_error": "Could not load the Lite catalog.",
    "staff_essentials_invites_content_preset_title": "Content Groups",
    "staff_essentials_invites_content_preset_description": "Select one or more groups to replace the current selection with their combined content. Customize individual items in Advanced Options.",
    "staff_essentials_invites_content_preset_placeholder": "Predefined content group",
    "staff_essentials_invites_content_preset_custom": "Custom selection (no preset)",
    "staff_essentials_invites_content_preset_loading": "Loading content presets...",
    "staff_essentials_invites_content_preset_error": "Could not load the content presets.",
    "staff_essentials_invites_content_preset_empty": "No active content presets are available. You can still select content manually.",
    "staff_essentials_invites_content_preset_applied": "Preset applied",
    "staff_essentials_invites_content_preset_applied_description": "This content was copied into the invitation. You can customize it below without changing the Strapi group.",
    "exclusive_content_title": "Exclusive content",
    "exclusive_content_message": "This resource is not included in your current access. Contact the person who provided your invitation or your MagVenture representative to discuss access. You can continue exploring the resources available in your portal.",
    "continue_browsing": "Continue browsing",
    "survey_load_error": "We could not load this survey.",
    "survey_unavailable": "Survey unavailable",
    "survey_back_to_course": "Back to course",
    "survey_thank_you": "Thank you for your feedback",
    "survey_completed_description": "Your answers were saved. You can continue with the course.",
    "survey_submitted": "Submitted",
    "survey_continue_course": "Continue course",
    "survey_course_feedback": "Course feedback",
    "survey_intro_description": "Answer the following questions about your training experience.",
    "survey_questions": "questions",
    "survey_minutes": "minutes",
    "survey_account_linked": "Saved to your account",
    "survey_start": "Start survey",
    "survey_progress": "Survey progress",
    "survey_optional": "Optional",
    "survey_required": "Required",
    "survey_text_placeholder": "Type your answer here...",
    "survey_back": "Back",
    "survey_submit": "Submit feedback",
    "survey_continue": "Continue",
    "survey_required_answer": "This question is required.",
    "survey_required_before_quiz": "Complete the required survey before starting this quiz.",
    "survey_required_title": "Survey required",
    "survey_open": "Open survey",
    "survey_completed_action": "Survey completed",
    "survey_complete_required": "Complete required survey",
    "survey_course_completed": "Course complete",
    "survey_next_step": "Next step",
    "survey_share_experience": "Share your experience",
    "survey_opens_in": "Opening survey in",
    "survey_seconds": "seconds",
    "survey_answer_now": "Answer survey",
    "survey_stay_here": "Stay here",
    "user_approvals_menu_title": "User Approvals",
    "user_approvals_eyebrow": "Access management",
    "user_approvals_title": "User approvals",
    "user_approvals_subtitle": "Review the pending access requests assigned to your approval scope.",
    "user_approvals_pending_count": "pending",
    "user_approvals_refresh": "Refresh",
    "user_approvals_pending_requests": "Pending requests",
    "user_approvals_search_placeholder": "Search by name, email or company",
    "user_approvals_unavailable": "Approvals unavailable",
    "user_approvals_auth_required": "Sign in to access your approval requests.",
    "user_approvals_not_authorized": "No active approval recipient is linked to this account.",
    "user_approvals_network_error": "Network error. Please try again.",
    "user_approvals_load_error": "We could not load the approval requests.",
    "user_approvals_empty": "There are no pending approvals.",
    "user_approvals_empty_description": "New requests assigned to your approval scope will appear here.",
    "user_approvals_no_search_results": "No matching approvals",
    "user_approvals_no_search_results_description": "Try another name, email or company.",
    "user_approvals_created_at": "Created at",
    "user_approvals_name": "Name",
    "user_approvals_email": "Email",
    "user_approvals_edit_company_name": "Edit company name (optional)",
    "user_approvals_partner_description": "Review the registration and approve or reject access. You can optionally correct the company name.",
    "user_approvals_company": "Company name",
    "user_approvals_country": "Country",
    "user_approvals_region": "Region",
    "user_approvals_location": "Location",
    "user_approvals_status": "Status",
    "user_approvals_actions": "Actions",
    "user_approvals_approved": "Approved",
    "user_approvals_rejected": "Rejected",
    "user_approvals_approve": "Approve",
    "user_approvals_reject": "Reject",
    "user_approvals_already_processed": "This approval request has already been processed.",
    "user_approvals_process_error": "We could not process this approval request.",
    "user_approvals_approve_success": "User approved successfully.",
    "user_approvals_reject_success": "User rejected successfully.",
    "user_approvals_manual_review_required": "Manual review required",
    "user_approvals_company_informed": "Company name entered at registration",
    "user_approvals_phone": "Phone",
    "user_approvals_customer_select": "Company name (Account in Salesforce)",
    "user_approvals_customer_search_placeholder": "Search or select a Salesforce Account",
    "user_approvals_search_companies": "Search for a customer or clinic",
    "user_approvals_no_companies": "No matching customer or clinic found",
    "user_approvals_company_load_error": "We could not load customer or clinic options.",
    "user_approvals_confirm_title": "Approve user",
    "user_approvals_confirm_description": "Review the registration and confirm the customer association before approving access.",
    "user_approvals_organization_verification_title": "Action Required: Verify User's Organization",
    "user_approvals_organization_verification_intro": "Every MagVenture Universe user from a directly managed market must be associated with the correct company or organization in Salesforce before access can be approved.",
    "user_approvals_organization_verification_context": "This association helps the MagVenture team identify the customer and track their interests and engagement with Universe content.",
    "user_approvals_organization_verification_steps_title": "What you need to do:",
    "user_approvals_organization_verification_review_title": "Review the suggested organizations",
    "user_approvals_organization_verification_review_text": "Review the Salesforce Accounts suggested below. The system searches for potential matches based on the company information provided during registration.",
    "user_approvals_organization_verification_select_title": "Select the correct organization",
    "user_approvals_organization_verification_select_text": "If you find the correct Salesforce Account, select it to associate the user with that organization.",
    "user_approvals_organization_verification_no_match_title": "If no matching organization is found",
    "user_approvals_organization_verification_no_match_text": "If you cannot identify the correct organization, contact the MagVenture Universe Team for assistance.",
    "user_approvals_organization_verification_reject_text": "If the user's eligibility cannot be verified, reject the registration.",
    "user_approvals_important": "Important:",
    "user_approvals_organization_verification_important": "A confirmed Salesforce Account association is required before approving this user.",
    "user_approvals_association_confirmation": "This user will be associated with:",
    "user_approvals_use_registered_company": "Approve with the clinic entered at registration",
    "user_approvals_registered_company_confirmation": "A Salesforce Contact will be created using the registration details. Clinic entered:",
    "user_approvals_confirm_approval": "Confirm approval",
    "analytics_hub_traffic": "Competitive Hub traffic",
    "analytics_hub_page": "Page",
    "mag.title": "Maggie",
    "mag.subtitle": "Your learning companion",
    "mag.preview_badge": "Pilot",
    "mag.open_aria": "Open Maggie assistant",
    "mag.close_aria": "Close Maggie assistant",
    "mag.launcher_tooltip": "Talk to Maggie",
    "mag.intro_title": "Hi! I'm Maggie.",
    "mag.intro_body": "How can I help?",
    "mag.dismiss_intro_aria": "Dismiss Maggie introduction",
    "mag.welcome": "Hi! I'm Maggie. What would you like to explore today?",
    "mag.welcome_named": "Hi, {name}! I'm Maggie. What would you like to explore today?",
    "mag.quick.hub_news": "Latest Competitive Hub news",
    "mag.quick.hub_research": "Recent Competitive Hub research",
    "mag.quick.hub_events": "Upcoming Competitive Hub events",
    "mag.quick_actions_label": "Try asking",
    "mag.quick.find_course": "Find a course",
    "mag.quick.explore_trails": "Explore Learning Paths",
    "mag.quick.continue_learning": "Continue learning",
    "mag.quick.product_tutorials": "Find product tutorials",
    "mag.quick.about_magventure": "Learn how MagVenture works",
    "mag.placeholder": "Ask Maggie a question...",
    "mag.composer_label": "Message to Maggie",
    "mag.send_aria": "Send message to Maggie",
    "mag.preview_response": "I can answer from the MagVenture learning library.",
    "mag.local_error": "Maggie could not prepare a response. Please try again.",
    "mag.typing": "Maggie is preparing a response",
    "mag.you_label": "Your message",
    "mag.mag_label": "Message from Maggie",
    "mag.avatar_fallback": "Maggie avatar fallback",
    "mag.loading": "Opening Maggie...",
    "mag.sources": "Sources",
    "mag.page": "Page",
    "mag.feedback_question": "Was this helpful?",
    "mag.feedback_up": "Helpful response",
    "mag.feedback_down": "Unhelpful response",
    "mag.feedback_thanks": "Thanks for your feedback.",
    "mag.feedback_error": "Feedback could not be sent. Please try again.",
    "mag.feedback_form.title": "Share feedback",
    "mag.feedback_form.open": "Click here to share feedback",
    "staff_essentials_invites_content_locked": "Locked",
    "staff_essentials_invites_content_available": "Access granted",
    "mag.feedback_form.description": "Your feedback will be saved in our internal inbox for the MagVenture team to review. Up to 4,000 characters.",
    "mag.feedback_form.placeholder": "Your feedback",
    "mag.feedback_form.submit": "Submit feedback",
    "mag.feedback_form.cancel": "Back to chat",
    "mag.competitor_feedback.prompt": "Hi! I can help you explore the Competitive Hub. What would you like to know? You can also use the feedback button below to share a suggestion.",
    "mag.competitor_feedback.prompt_named": "Hi, {name}! I can help you explore the Competitive Hub. What would you like to know? You can also use the feedback button below to share a suggestion.",
    "mag.competitor_feedback.placeholder": "Share your Competitor Hub feedback...",
    "mag.competitor_feedback.success": "Thank you! Your feedback has been saved for our team to review.",
    "mag.competitor_feedback.error": "Your feedback could not be saved. Your message is still in the form; please try again.",
    "mag.feedback_reason.not_helpful": "Not helpful",
    "mag.feedback_reason.wrong_source": "Wrong source",
    "mag.feedback_reason.unclear": "Unclear",
    "mag.feedback_reason.too_general": "Too general",
    "mag.feedback_reason.unsafe": "Unsafe",
    "competitive_intelligence_menu_title": "Competitive Intelligence",
    "competitive_intelligence_eyebrow": "Market intelligence",
    "competitive_intelligence_title": "Competitive Intelligence",
    "competitive_intelligence_description": "A current view of the competitive research, market signals, and social sources tracked by MagVenture.",
    "competitive_intelligence_freshness_unknown": "Update time unavailable",
    "competitive_intelligence_overview_heading": "Intelligence overview",
    "competitive_intelligence_metric_competitors": "Competitors tracked",
    "competitive_intelligence_metric_research": "Research records",
    "competitive_intelligence_metric_market": "Market signals",
    "competitive_intelligence_metric_social": "Social posts",
    "competitive_intelligence_sources_title": "Research sources",
    "competitive_intelligence_sources_description": "Coverage and freshness from the current Competitive Intelligence database.",
    "competitive_intelligence_records": "records",
    "competitive_intelligence_sources_empty": "No source-level details are available yet.",
    "competitive_intelligence_loading": "Loading Competitive Intelligence overview",
    "competitive_intelligence_empty_title": "No intelligence data yet",
    "competitive_intelligence_empty_description": "The data pipeline has not published Overview records yet.",
    "competitive_intelligence_denied_title": "Access not available",
    "competitive_intelligence_denied_description": "Your account does not have access to Competitive Intelligence.",
    "competitive_intelligence_unavailable_title": "Competitive Intelligence is unavailable",
    "competitive_intelligence_unavailable_description": "The service cannot be reached right now. Please try again shortly.",
    "competitive_intelligence_error_title": "Overview could not be loaded",
    "competitive_intelligence_error_description": "An unexpected response prevented this Overview from loading.",
    ...competitiveIntelligenceResearchTranslations.English
}
